import { CommonAPI } from "../Client";

const buildBodyWithoutCompanyId = (payload = {}) => {
  const { companyId, ...body } = payload;
  return body;
};

export const getCompanyShiprocketDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.get(
      `/company/shiprocket/detail?companyId=${payload?.companyId || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyShiprocketDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/company/shiprocket/detail?companyId=${payload?.companyId || 0}`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyShiprocketDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/company/shiprocket/detail`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyRazorpayDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.get(
      `/company/razorpay/detail?companyId=${payload?.companyId || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyRazorpayDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/company/razorpay/detail?companyId=${payload?.companyId || 0}`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyRazorpayDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/company/razorpay/detail`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyOauthDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.get(
      `/company/oauth/detail?companyId=${payload?.companyId || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyOauthDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/company/oauth/detail?companyId=${payload?.companyId || 0}`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyOauthDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/company/oauth/detail`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCompanyAnalyticDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.get(
      `/company/analytic/detail?companyId=${payload?.companyId || 0}`,
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const postCompanyAnalyticDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.post(
      `/company/analytic/detail?companyId=${payload?.companyId || 0}`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateCompanyAnalyticDetailApi = async (payload) => {
  try {
    const response = await CommonAPI.put(
      `/company/analytic/detail`,
      buildBodyWithoutCompanyId(payload),
    );
    return response;
  } catch (error) {
    throw error;
  }
};
